export const MAX_FILE_SIZE = 500 * 1024;
export const CONTENT_PACKAGE_NONE_ELEMENT_ID = '0';
export const DEFAULT_CREATIVES_QUANTITY = 1;
export const MIN_NUMBER_OF_CREATIVES = 1;
export const MAX_NUMBER_OF_CREATIVES = 50;
export const MIN_BONUS_IMPRESSIONS_VALUE = 1000;

export const MAXIMUM_IMAGE_CREATIVES_COUNT = 2;
